import React, {Suspense} from 'react';
import {Routes, Route, Navigate} from "react-router-dom";

import Login from '../../pages/Login';
import ForgotPassword from '../../pages/ForgotPassword';
import SetPassword from '../../pages/SetPassword';
import GeneratePdf from '../../pages/GeneratePdfAndSave';

const UnauthRoutes = () => {
  return (
    <Suspense>
        <Routes>
            <Route 
                path="/"
                element={<Login/>}
            />
            <Route 
                path="/forgot-password"
                element={<ForgotPassword/>}
            />
            <Route 
                path="/set-password/:id" //for first time account activation
                element={<SetPassword reset={false}/>}
            />
            <Route 
                path="/reset-password/:id" //for flows where user forgot password
                element={<SetPassword reset={true}/>}
            />
            <Route 
                path="/job-management/:id/generate-pdf" //for flows where user forgot password
                element={<GeneratePdf />}
            />
            <Route 
                path="*"
                element={<Navigate to="/"/>}
            />
        </Routes>
    </Suspense>
  )
}

export default UnauthRoutes